import { sbRespNotificationUnavailableItemModalConfig } from './SbRespNotificationUnavailableItem/sbRespnotificationUnavailableItemConfig';

export const sbRespNotifications = [sbRespNotificationUnavailableItemModalConfig];
